import { render } from "./ChatMenu.vue?vue&type=template&id=668be6fa&scoped=true&ts=true"
import script from "./ChatMenu.vue?vue&type=script&lang=ts"
export * from "./ChatMenu.vue?vue&type=script&lang=ts"

import "./ChatMenu.vue?vue&type=style&index=0&id=668be6fa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-668be6fa"]])

export default __exports__